import { Component, OnInit } from '@angular/core';
import { Subject, takeUntil } from "rxjs";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { MessageService } from "primeng/api";
import { TaxRateModel } from "../../../models/tax-rates/tax-rate.model";
import { MenuService } from "../../../services/menus/menu.service";

@Component({
  selector: 'app-add-or-edit-tax-rate',
  templateUrl: './add-or-edit-tax-rate.component.html',
  styleUrls: ['./add-or-edit-tax-rate.component.scss']
})
export class AddOrEditTaxRateComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public taxRateModel: TaxRateModel = new TaxRateModel();
  public errorModel: { [k: string]: any } = {};
  public spinner: boolean = false;
  public enableEdit: boolean = false;
  public taxRateId: string;
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
  public invalidInputErrorMessage = "INFO.INVALID_VALUE";
  public disableDefaultDeselect: boolean = false;
  //#endregion

  //#region Constructor
  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    public dialogService: DialogService,
    private menuService: MenuService,
    private messageService: MessageService
  ) {
    if (this.config.data != undefined && this.config.data.id) {
      this.taxRateId = this.config.data.id;
      this.loadTaxRateDetails();
      this.enableEdit = true;
    }
  }

  ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  publishOrUpdateTaxRate(model: TaxRateModel, update: boolean = false) {
    this.errorModel = {};

    if (model && model.name.trim() === "") {
      this.errorModel['Name'] = this.requiredFieldErrorMessage;
    }

    if (model && (model.rate === undefined || model.rate === null)) {
      this.errorModel['Rate'] = this.requiredFieldErrorMessage;
    } else if (model.rate < 0) {
      this.errorModel['Rate'] = this.invalidInputErrorMessage;
    }

    if (Object.keys(this.errorModel).length === 0) {
      this.spinner = true;

      if (update) {
        this.menuService.updateTaxRate(model)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: _ => {
              this.spinner = false;
              this.ref.close(true)
            },
            error: _ => {
              this.spinner = false;
              this.messageService.add({severity: 'error', summary: "System error", life: 2000});
            }
          });
      } else {
        this.menuService.publishTaxRate(model)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: _ => {
              this.spinner = false;
              this.ref.close(true)
            },
            error: _ => {
              this.spinner = false;
              this.messageService.add({severity: 'error', summary: "System error", life: 2000});
            }
          });
      }
    }
  }

  public loadTaxRateDetails(): void {
    this.spinner = true;
    this.menuService.loadTaxRateDetails(this.taxRateId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.taxRateModel = response;
          this.disableDefaultDeselect = this.taxRateModel.isDefault;
          this.spinner = false;
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }
  //#endregion
}
